import { useEffect } from 'react';
import { HANDLE_MESSAGES_REQUEST } from '../utils';

export const useAutoSaveDraft = ({
  draft,
  message,
  profile,
  ticket,
  subject,
  editor,
  receiverList,
  recipientType,
  attachments,
  setIsLoadingSave,
  mutateTicket,
  mutate,
  isLoading,
  editorHasChanged,
  setEditorHasChanged,
}) => {
  useEffect(() => {
    if (isLoading) return;
    if (!editor) return;
    if (!editorHasChanged) return;
    if (!draft?._id) return;
    let cancel = false;

    (async () => {
      if (cancel) return;
      try {
        await HANDLE_MESSAGES_REQUEST.saveMessage({
          draft,
          profile,
          ticket,
          subject,
          content: editor.getHTML(),
          receiverList,
          recipientType,
          mutateTicket,
          mutate,
          setIsLoadingSave,
          setIsMessageBoxHidden: () => {}, // pas besoin de le faire ici
          emptyFormFields: () => {}, // pas besoin de le faire ici
        });
        setEditorHasChanged(false);
      } catch (error) {
        console.error('AutoSave draft error:', error);
        setIsLoadingSave(false);
        setEditorHasChanged(false);
        throw new Error(error);
      }
    })();

    return () => {
      cancel = true;
    };
  }, [
    message,
    profile,
    ticket,
    subject,
    editor,
    receiverList,
    recipientType,
    attachments,
    isLoading,
    editorHasChanged,
  ]);
};
